<script>
const columns = [
  {
		key: 'filename',
		title: "File",
		scopedSlots: {customRender: 'filename'}
	}, {
		key: 'filesize',
		title: 'Size',
		scopedSlots: {customRender: 'filesize'}
	}, {
		key: 'filetime',
		title: 'Last Modify',
		scopedSlots: {customRender: 'filetime'}
	}, {
		key: 'fileurl',
		title: '',
		align: 'center',
		scopedSlots: {customRender: 'fileurl'}
	}
]

export default {
  data() {
    return {
      columns,
      items: [],
      loading: false,
    }
  },

  created() {
    this.getItems()
  },

  methods: {
    getItems() {
      this.loading = true

      this.$http.get(this.routeUri('hyperion.attachment.download.center'))
        .then((response) => {
          this.items = response.data.sort((a, b) => {
            return new Date(b.filetime) - new Date(a.filetime)
          })
        })
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    download(url) {
      window.open(window.location.origin + url, '_blank')
    },
  }
}
</script>
<template>
  <a-card type="inner" size="small">
    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="this.items" rowKey="filename">
        <div slot="filename" slot-scope="record">
          <span class="text-sm text-muted">
              <a-icon type="paper-clip" /> <code>{{ record.filename }}</code>
          </span>
        </div>
        <div slot="filesize" slot-scope="record">
          <span class="text-sm text-muted">
              <code>{{ Math.round(record.filesize / 1024) }} KB</code>
          </span>
        </div>
        <div slot="filetime" slot-scope="record">
          <span class="text-sm text-muted">
              <code>{{ record.filetime }}</code>
          </span>
        </div>
        <div slot="fileurl" slot-scope="record" class="text-center">
          <a-space>
            <a-tooltip title="Download File">
              <a-button type="link" size="small" @click="download(record.fileurl)">
                <a-icon type="file-text" theme="twoTone" two-tone-color="#3452eb" />
              </a-button>
            </a-tooltip>
          </a-space>
        </div>
      </a-table>
    </a-skeleton>
  </a-card>
</template>
